import React from 'react';
interface Props {
  width?: number;
  color1?: string;
  color2?: string;
}
function IllustrationCompteSvg(props: Props) {
  return (
    <svg
      id="Calque_1"
      data-name="Calque 1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 445.89 298.1"
    >
      <defs>
        <linearGradient
          id="Dégradé_sans_nom_2"
          x1="-628.26"
          y1="-1607.2"
          x2="-628.26"
          y2="-1711.89"
          gradientTransform="matrix(0.54, -0.84, -0.84, -0.54, -997.78, -1170.76)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor={props.color2 ? props.color2 : '#ffa1a1'} />
          <stop offset="1" stopColor={props.color1 ? props.color1 : '#ff4137'} />
        </linearGradient>
        <linearGradient
          id="Dégradé_sans_nom_3"
          x1="575.14"
          y1="-689.48"
          x2="631.9"
          y2="-689.48"
          gradientTransform="matrix(0.65, -0.76, -0.76, -0.65, -828.61, 235.95)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#ebeef7" />
          <stop offset="1" stopColor="#9297a5" />
        </linearGradient>
        <linearGradient
          id="Dégradé_sans_nom_4"
          x1="-489.56"
          y1="166.26"
          x2="-517.45"
          y2="217.6"
          gradientTransform="translate(-110.51 308.78) rotate(-166.51)"
          xlinkHref="#Dégradé_sans_nom_2"
        />
        <linearGradient
          id="Dégradé_sans_nom_5"
          x1="-448.07"
          y1="174.07"
          x2="-495.24"
          y2="229.62"
          gradientTransform="translate(-110.51 308.78) rotate(-166.51)"
          xlinkHref="#Dégradé_sans_nom_3"
        />
      </defs>
      <g id="Calque_3" data-name="Calque 3">
        <g id="fond_gradient" data-name="fond gradient" opacity="0.5">
          <path
            d="M436.3,284.7c0-5.2-80.4-9.4-179.6-9.4s-179.6,4.2-179.6,9.4C62.3,270.2,54.4,243.3,58.7,223S82,185.4,82.4,164.6c.7-34.3-20.7-69.2-8.6-101.4,9.8-26,34.9-50.4,67.7-50.4,27.8,0,58.5,15.3,83.3,27.6s46.4,26.3,73.9,30.2c19.5,2.8,42.5,1.3,62,4,43.3,6,82.3,37.8,97,79S466,252.6,436.3,284.7Z"
            transform="translate(-19.4 -12.8)"
            fill="#c3cae5"
            fill-rule="evenodd"
          />
        </g>
        <g opacity="0.35">
          <path
            d="M380,241.3h-.1a.56.56,0,0,1-.5-.6c8.4-75.3,18.7-129.2,29-151.9a9.42,9.42,0,0,0,.4-1,.54.54,0,0,1,1,.4c-.1.2-.2.6-.5,1.2C399,112,388.8,165.8,380.4,241A.45.45,0,0,1,380,241.3Z"
            transform="translate(-19.4 -12.8)"
            fill="#c3cae5"
          />
          <path
            d="M417.4,83.3c-1.2,2.6-8.8,8.2-9.6,7.9s-1-9.8.3-12.4a5.17,5.17,0,1,1,9.3,4.5Z"
            transform="translate(-19.4 -12.8)"
            fill="#c3cae5"
          />
          <path
            d="M402.6,93.1c1.3,2.6,1.3,12.3.6,12.7s-8.6-5.3-9.9-7.9a5.29,5.29,0,0,1,2.3-7.1A5.2,5.2,0,0,1,402.6,93.1Z"
            transform="translate(-19.4 -12.8)"
            fill="#c3cae5"
          />
          <path
            d="M415.5,107.7c-2.8.7-12.3-1.5-12.5-2.3s7.1-7.2,9.9-7.9a5.29,5.29,0,0,1,6.4,3.8A5.14,5.14,0,0,1,415.5,107.7Z"
            transform="translate(-19.4 -12.8)"
            fill="#c3cae5"
          />
          <path
            d="M386.8,144.9c2.7,4.1,4.4,20.3,3.2,21s-15.3-7.2-18-11.3a8.85,8.85,0,1,1,14.8-9.7Z"
            transform="translate(-19.4 -12.8)"
            fill="#c3cae5"
          />
          <path
            d="M411,166.9c-4.6,1.7-20.7-.3-21.2-1.6s10.5-13.3,15.1-15a8.84,8.84,0,1,1,6.1,16.6Z"
            transform="translate(-19.4 -12.8)"
            fill="#c3cae5"
          />
          <path
            d="M377.5,165.1c4.3,4.2,10.7,23,9.5,24.2s-20.2-4.5-24.5-8.6a10.87,10.87,0,0,1-.3-15.3A10.69,10.69,0,0,1,377.5,165.1Z"
            transform="translate(-19.4 -12.8)"
            fill="#c3cae5"
          />
          <path
            d="M411.6,193.3c-5.8,1.5-25.2-3-25.6-4.6s14.4-14.9,20.2-16.4a10.84,10.84,0,0,1,5.4,21Z"
            transform="translate(-19.4 -12.8)"
            fill="#c3cae5"
          />
          <path
            d="M374,189.7c4.3,4.2,10.7,23,9.5,24.2s-20.2-4.5-24.5-8.6a10.82,10.82,0,0,1,15-15.6Z"
            transform="translate(-19.4 -12.8)"
            fill="#c3cae5"
          />
          <path
            d="M408.1,218c-5.8,1.5-25.2-3-25.6-4.6s14.4-14.9,20.2-16.4a10.84,10.84,0,0,1,5.4,21Z"
            transform="translate(-19.4 -12.8)"
            fill="#c3cae5"
          />
          <path
            d="M362.4,222.1c5.6,2.2,18.6,17.2,18,18.8s-20.4,3.6-26,1.4a10.86,10.86,0,0,1,8-20.2Z"
            transform="translate(-19.4 -12.8)"
            fill="#c3cae5"
          />
          <path
            d="M405.5,242.3c-5.6,2.2-25.4.2-26-1.4s12.5-16.6,18-18.8a10.86,10.86,0,1,1,8,20.2Z"
            transform="translate(-19.4 -12.8)"
            fill="#c3cae5"
          />
          <path
            d="M397.7,109.3c1.3,2.6,1.3,12.5.6,12.9s-8.8-5.3-10.1-8a5.4,5.4,0,0,1,2.3-7.2A5.21,5.21,0,0,1,397.7,109.3Z"
            transform="translate(-19.4 -12.8)"
            fill="#c3cae5"
          />
          <path
            d="M410.5,124.3c-2.9.7-12.5-1.5-12.7-2.3s7.2-7.3,10-8a5.33,5.33,0,0,1,6.5,3.9A5.07,5.07,0,0,1,410.5,124.3Z"
            transform="translate(-19.4 -12.8)"
            fill="#c3cae5"
          />
          <path
            d="M391.6,124.5c2.2,3.6,3.3,17.5,2.3,18.1s-13-6.5-15.2-10.1a7.63,7.63,0,0,1,2.5-10.5A7.53,7.53,0,0,1,391.6,124.5Z"
            transform="translate(-19.4 -12.8)"
            fill="#c3cae5"
          />
          <path
            d="M411.7,145.5c-4.1,1-17.7-2.2-18-3.3s10.2-10.4,14.3-11.4a7.61,7.61,0,0,1,9.2,5.5A7.54,7.54,0,0,1,411.7,145.5Z"
            transform="translate(-19.4 -12.8)"
            fill="#c3cae5"
          />
        </g>
        <g opacity="0.35">
          <path
            d="M156.1,254.1h0a.42.42,0,0,0,.3-.6c-19.5-57.4-36.9-97.8-48.8-113.8-.3-.4-.5-.6-.5-.7a.45.45,0,0,0-.8.4,8,8,0,0,0,.6.8c11.9,15.9,29.2,56.2,48.7,113.5A.51.51,0,0,0,156.1,254.1Z"
            transform="translate(-19.4 -12.8)"
            fill="#c3cae5"
          />
          <path
            d="M99.6,137.1c1.4,1.8,8.3,4.9,8.8,4.5s-.9-7.8-2.4-9.6a4.13,4.13,0,0,0-5.8-.7A4.21,4.21,0,0,0,99.6,137.1Z"
            transform="translate(-19.4 -12.8)"
            fill="#c3cae5"
          />
          <path
            d="M112.9,142.2c-.6,2.3,1.1,9.8,1.8,10s5.8-5.6,6.4-7.9a4.28,4.28,0,0,0-3-5.2A4.34,4.34,0,0,0,112.9,142.2Z"
            transform="translate(-19.4 -12.8)"
            fill="#c3cae5"
          />
          <path
            d="M105.3,155.8c2.3.1,9.3-3.3,9.3-4s-6.8-4.4-9.1-4.5a4.25,4.25,0,0,0-.2,8.5Z"
            transform="translate(-19.4 -12.8)"
            fill="#c3cae5"
          />
          <path
            d="M134.2,179.9c-1.4,3.7.1,16.6,1.1,17s10.7-8.3,12.1-11.9a7.08,7.08,0,0,0-13.2-5.1Z"
            transform="translate(-19.4 -12.8)"
            fill="#c3cae5"
          />
          <path
            d="M119,201.3c3.9.5,16.2-3.8,16.3-4.9s-10.5-8.6-14.4-9.1a7.06,7.06,0,1,0-1.9,14Z"
            transform="translate(-19.4 -12.8)"
            fill="#c3cae5"
          />
          <path
            d="M144.9,194.1c-2.6,4-4.4,19.8-3.2,20.6s15.1-7,17.7-11a8.69,8.69,0,0,0-14.5-9.6Z"
            transform="translate(-19.4 -12.8)"
            fill="#c3cae5"
          />
          <path
            d="M123.1,222.1c4.8.2,19.2-6.7,19.2-8s-13.9-9.1-18.6-9.3a8.66,8.66,0,1,0-.6,17.3Z"
            transform="translate(-19.4 -12.8)"
            fill="#c3cae5"
          />
          <path
            d="M151.9,212.8c-2.6,4-4.4,19.8-3.2,20.6s15.1-7,17.7-11a8.69,8.69,0,0,0-14.5-9.6Z"
            transform="translate(-19.4 -12.8)"
            fill="#c3cae5"
          />
          <path
            d="M130.1,240.8c4.8.2,19.2-6.7,19.2-8s-13.9-9.1-18.6-9.3a8.66,8.66,0,1,0-.6,17.3Z"
            transform="translate(-19.4 -12.8)"
            fill="#c3cae5"
          />
          <path
            d="M166.5,236.1c-4,2.7-11.6,16.7-10.8,17.8s16.6-.7,20.6-3.4a8.71,8.71,0,0,0-9.8-14.4Z"
            transform="translate(-19.4 -12.8)"
            fill="#c3cae5"
          />
          <path
            d="M136.3,259.3c4.7.8,19.9-4.2,20.1-5.6s-12.6-10.8-17.3-11.6a8.71,8.71,0,0,0-2.8,17.2Z"
            transform="translate(-19.4 -12.8)"
            fill="#c3cae5"
          />
          <path
            d="M119.5,153.9c-.6,2.3,1.1,10,1.8,10.2s5.9-5.7,6.5-8a4.26,4.26,0,0,0-3.1-5.2A4.2,4.2,0,0,0,119.5,153.9Z"
            transform="translate(-19.4 -12.8)"
            fill="#c3cae5"
          />
          <path
            d="M112,167.9c2.4.1,9.5-3.3,9.5-4s-6.9-4.5-9.2-4.6a4.3,4.3,0,0,0-.3,8.6Z"
            transform="translate(-19.4 -12.8)"
            fill="#c3cae5"
          />
          <path
            d="M126.9,164.8c-1.1,3.2.4,14.3,1.3,14.6s9-7.4,10.2-10.5a6.17,6.17,0,0,0-3.7-7.8A6.09,6.09,0,0,0,126.9,164.8Z"
            transform="translate(-19.4 -12.8)"
            fill="#c3cae5"
          />
          <path
            d="M114.8,184.7c3.4.1,13.5-4.7,13.5-5.7s-9.8-6.4-13.1-6.5a6.13,6.13,0,0,0-6.3,5.9A6.06,6.06,0,0,0,114.8,184.7Z"
            transform="translate(-19.4 -12.8)"
            fill="#c3cae5"
          />
        </g>
        <g id="feuilles1">
          <path
            d="M19.4,221.9s13.3,33.8,46.4,54.9S109,279,109,279s12.9-17.1-20.2-38.2S19.4,221.9,19.4,221.9Z"
            transform="translate(-19.4 -12.8)"
            fill="url(#Dégradé_sans_nom_2)"
          />
          <path
            d="M109.4,279.2c-.1.1-.3.2-.4.1l-81.7-52c-.1-.1-.2-.3-.1-.4s.3-.2.4-.1l81.7,52C109.4,278.9,109.5,279.1,109.4,279.2Z"
            transform="translate(-19.4 -12.8)"
            fill="#fff"
          />
          <path
            d="M47.4,239.6c0-.1,1.5-8.3-1-15.4-.2,0-.4-.1-.7-.1,2.6,7,1.1,15.3,1.1,15.4Z"
            transform="translate(-19.4 -12.8)"
            fill="#fff"
          />
          <path
            d="M32.1,229.9a39.07,39.07,0,0,0,.4-7.6h-.6a36.77,36.77,0,0,1-.4,7.5Z"
            transform="translate(-19.4 -12.8)"
            fill="#fff"
          />
          <path
            d="M55.4,244.7c0-.1,1.9-10.7-1.9-18.9-.3-.1-.5-.1-.8-.2,4,8,2.1,18.8,2.1,19Z"
            transform="translate(-19.4 -12.8)"
            fill="#fff"
          />
          <path
            d="M90.1,266.8c0-.2,2.8-15.6-3-27.1-.3-.2-.7-.4-1-.6,6.3,11.4,3.4,27.4,3.4,27.6Z"
            transform="translate(-19.4 -12.8)"
            fill="#fff"
          />
          <path
            d="M102.3,274.8l.6.1c0-.2,2.4-13.7-2-24.9a11,11,0,0,0-1.1-1C104.9,260.2,102.3,274.7,102.3,274.8Z"
            transform="translate(-19.4 -12.8)"
            fill="#fff"
          />
          <path
            d="M68.9,253.4c0-.2,2.3-12.9-1.9-23.4-.3-.1-.5-.2-.8-.3,4.4,10.4,2.1,23.4,2.1,23.6Z"
            transform="translate(-19.4 -12.8)"
            fill="#fff"
          />
          <path
            d="M29.8,240.9a36.12,36.12,0,0,0,11.3-5.1l-.3-.5a34.63,34.63,0,0,1-11.3,5C29.5,240.5,29.7,240.7,29.8,240.9Z"
            transform="translate(-19.4 -12.8)"
            fill="#fff"
          />
          <path
            d="M50.9,242.1l-.3-.5c-.1.1-7.7,5.4-15.9,6.1.1.2.3.4.4.6C43.3,247.4,50.8,242.1,50.9,242.1Z"
            transform="translate(-19.4 -12.8)"
            fill="#fff"
          />
          <path
            d="M81.5,261.6l-.3-.5c-.1.1-12.6,8.9-25.2,8.6.2.2.5.4.7.6C69.2,270.2,81.4,261.7,81.5,261.6Z"
            transform="translate(-19.4 -12.8)"
            fill="#fff"
          />
          <path
            d="M98.4,272.1c-.1.1-13.1,9.2-26,8.6l1.2.6c12.6,0,25-8.7,25.1-8.8Z"
            transform="translate(-19.4 -12.8)"
            fill="#fff"
          />
          <path
            d="M43.4,258c.2.2.3.4.5.5,10.7-1.1,20.4-8,20.5-8l-.3-.5C63.9,250.2,54.1,257.1,43.4,258Z"
            transform="translate(-19.4 -12.8)"
            fill="#fff"
          />
          <path
            d="M68.5,178.6s31.4,18.3,47.2,54.2-4.4,43-4.4,43S92.4,286,76.6,250,68.5,178.6,68.5,178.6Z"
            transform="translate(-19.4 -12.8)"
            fill="url(#Dégradé_sans_nom_3)"
          />
          <path
            d="M111.5,276.2c.2-.1.2-.2.2-.4l-39-88.6c-.1-.2-.2-.2-.4-.2s-.2.2-.2.4l39,88.6C111.2,276.2,111.4,276.3,111.5,276.2Z"
            transform="translate(-19.4 -12.8)"
            fill="#fff"
          />
          <path
            d="M81.8,208.9c-.1,0-8.4.2-15-3.3v-.7c6.5,3.6,14.9,3.4,15,3.4Z"
            transform="translate(-19.4 -12.8)"
            fill="#fff"
          />
          <path
            d="M74.5,192.4a34.91,34.91,0,0,1-7.6-.8V191a42.84,42.84,0,0,0,7.5.8Z"
            transform="translate(-19.4 -12.8)"
            fill="#fff"
          />
          <path
            d="M85.6,217.7c-.1,0-10.9.3-18.4-4.8a2.2,2.2,0,0,0-.1-.8c7.3,5.2,18.3,5,18.4,4.9Z"
            transform="translate(-19.4 -12.8)"
            fill="#fff"
          />
          <path
            d="M102.1,255.2c-.2,0-15.8.4-26.3-7.1-.1-.4-.3-.7-.4-1.1,10.3,7.9,26.5,7.5,26.7,7.5Z"
            transform="translate(-19.4 -12.8)"
            fill="#fff"
          />
          <path
            d="M108.2,268.5v.6c-.2,0-13.9.3-24.3-5.8-.3-.4-.5-.8-.8-1.2C93.4,268.9,108.1,268.5,108.2,268.5Z"
            transform="translate(-19.4 -12.8)"
            fill="#fff"
          />
          <path
            d="M92.1,232.3c-.2,0-13.1.3-22.9-5.5-.1-.3-.1-.5-.2-.8,9.6,6,22.8,5.7,23,5.6Z"
            transform="translate(-19.4 -12.8)"
            fill="#fff"
          />
          <path
            d="M85.7,191.7A39.32,39.32,0,0,1,79,202.1l-.4-.4a34.47,34.47,0,0,0,6.7-10.4C85.4,191.4,85.5,191.6,85.7,191.7Z"
            transform="translate(-19.4 -12.8)"
            fill="#fff"
          />
          <path
            d="M83.6,212.8l-.4-.4c.1-.1,6.5-6.8,8.4-14.8l.5.5C90.1,206.1,83.7,212.7,83.6,212.8Z"
            transform="translate(-19.4 -12.8)"
            fill="#fff"
          />
          <path
            d="M98.3,246l-.4-.4c.1-.1,10.7-11.2,12.4-23.6a5.58,5.58,0,0,0,.5.8C108.7,235.2,98.4,245.9,98.3,246Z"
            transform="translate(-19.4 -12.8)"
            fill="#fff"
          />
          <path
            d="M106.1,264.3c.1-.1,11.1-11.6,12.5-24.4.1.4.3.9.4,1.3-1.9,12.5-12.3,23.4-12.5,23.5Z"
            transform="translate(-19.4 -12.8)"
            fill="#fff"
          />
          <path
            d="M100.6,207.7c.2.2.3.4.5.6-2.8,10.4-11,19-11.1,19.1l-.4-.4C89.7,226.9,98,218.2,100.6,207.7Z"
            transform="translate(-19.4 -12.8)"
            fill="#fff"
          />
        </g>
        <path
          d="M72.3,288.6c0,12.3,86.7,22.3,193.6,22.3s193.6-10,193.6-22.3-86.7-22.3-193.6-22.3S72.3,276.2,72.3,288.6Z"
          transform="translate(-19.4 -12.8)"
          fill="#ebeef7"
        />
        <g id="feuilles2">
          <path
            d="M462.5,191.2s-1.4,31.4-22.4,57.9S405.4,263,405.4,263s-15.3-10.4,5.8-36.9S462.5,191.2,462.5,191.2Z"
            transform="translate(-19.4 -12.8)"
            fill="url(#Dégradé_sans_nom_4)"
          />
          <path
            d="M405.2,263.3a.3.3,0,0,0,.4,0l52-65.4a.28.28,0,0,0-.4-.4l-52,65.4A.3.3,0,0,0,405.2,263.3Z"
            transform="translate(-19.4 -12.8)"
            fill="#fff"
          />
          <path
            d="M444.6,213.5c0-.1-3.5-6.3-3.5-12.8.2-.1.3-.2.5-.3-.1,6.4,3.4,12.8,3.4,12.9Z"
            transform="translate(-19.4 -12.8)"
            fill="#fff"
          />
          <path
            d="M454.4,201.3a44.66,44.66,0,0,1-2.5-6.1c.2-.1.3-.1.5-.2a31,31,0,0,0,2.4,6Z"
            transform="translate(-19.4 -12.8)"
            fill="#fff"
          />
          <path
            d="M439.5,219.9c-.1-.1-4.6-8.2-3.7-16a2.09,2.09,0,0,0,.6-.4c-1,7.7,3.6,16,3.6,16.1Z"
            transform="translate(-19.4 -12.8)"
            fill="#fff"
          />
          <path
            d="M417.5,247.7c-.1-.1-6.6-11.9-5.2-22.9.2-.3.4-.5.6-.8-1.9,11.1,4.9,23.3,5,23.4Z"
            transform="translate(-19.4 -12.8)"
            fill="#fff"
          />
          <path
            d="M409.8,257.7l-.4.3c-.1-.1-5.9-10.5-5.4-20.9.2-.4.4-.7.6-1.1C403.5,246.5,409.7,257.6,409.8,257.7Z"
            transform="translate(-19.4 -12.8)"
            fill="#fff"
          />
          <path
            d="M431,230.8c-.1-.1-5.5-9.9-5-19.7a2.18,2.18,0,0,0,.5-.4c-.7,9.7,4.9,19.7,4.9,19.8Z"
            transform="translate(-19.4 -12.8)"
            fill="#fff"
          />
          <path
            d="M459.4,209.6a29.26,29.26,0,0,1-10.6-1l.1-.5a31.41,31.41,0,0,0,10.6.9C459.5,209.2,459.4,209.4,459.4,209.6Z"
            transform="translate(-19.4 -12.8)"
            fill="#fff"
          />
          <path
            d="M442.5,216.5l.1-.5c.1,0,7.8,2.3,14.7.5-.1.2-.1.4-.2.6C450.2,218.7,442.6,216.5,442.5,216.5Z"
            transform="translate(-19.4 -12.8)"
            fill="#fff"
          />
          <path
            d="M423,241l.1-.5c.1,0,12.8,3.7,23-.1-.1.2-.3.5-.4.7C435.4,244.6,423.1,241.1,423,241Z"
            transform="translate(-19.4 -12.8)"
            fill="#fff"
          />
          <path
            d="M412.1,254.3c.2,0,13.3,3.8,23.6-.3a6,6,0,0,1-.8.8c-10.3,3.6-22.8,0-23-.1Z"
            transform="translate(-19.4 -12.8)"
            fill="#fff"
          />
          <path
            d="M453.1,227.4l-.3.6c-9.1,2.1-18.9-.8-19-.8l.1-.5C434.1,226.7,444.1,229.6,453.1,227.4Z"
            transform="translate(-19.4 -12.8)"
            fill="#fff"
          />
          <path
            d="M421.8,155.1s-28.3,24.6-37.4,64,12.7,42.7,12.7,42.7,21.1,6.6,30.2-32.8S421.8,155.1,421.8,155.1Z"
            transform="translate(-19.4 -12.8)"
            fill="url(#Dégradé_sans_nom_5)"
          />
          <path
            d="M397,262.2c-.2,0-.3-.2-.2-.4l22.5-97.2c0-.2.2-.3.4-.2s.3.2.2.4L397.3,262C397.3,262.2,397.1,262.3,397,262.2Z"
            transform="translate(-19.4 -12.8)"
            fill="#fff"
          />
          <path
            d="M414.2,188.4c.1,0,8.5-1.4,14.6-6.2,0-.2-.1-.5-.1-.7-5.9,4.9-14.5,6.3-14.6,6.3Z"
            transform="translate(-19.4 -12.8)"
            fill="#fff"
          />
          <path
            d="M418.4,170.2a39.12,39.12,0,0,0,7.5-2.2c-.1-.2-.1-.4-.2-.6a39.12,39.12,0,0,1-7.5,2.2Z"
            transform="translate(-19.4 -12.8)"
            fill="#fff"
          />
          <path
            d="M412,197.9c.1,0,11.1-1.8,17.7-8.4,0-.3-.1-.5-.1-.8-6.4,6.7-17.6,8.5-17.7,8.5Z"
            transform="translate(-19.4 -12.8)"
            fill="#fff"
          />
          <path
            d="M402.4,239.2c.2,0,16.1-2.6,25.3-12.2a5,5,0,0,0,.2-1.2c-8.9,10-25.4,12.7-25.6,12.7Z"
            transform="translate(-19.4 -12.8)"
            fill="#fff"
          />
          <path
            d="M398.8,253.8l.1.6c.2,0,14.2-2.3,23.5-10.5.2-.4.4-.9.6-1.4C413.9,251.3,399,253.8,398.8,253.8Z"
            transform="translate(-19.4 -12.8)"
            fill="#fff"
          />
          <path
            d="M408.1,214c.2,0,13.4-2.2,22.1-9.9v-.8c-8.6,7.9-22.1,10.1-22.2,10.1Z"
            transform="translate(-19.4 -12.8)"
            fill="#fff"
          />
          <path
            d="M406.9,171.7a34.93,34.93,0,0,0,8.8,9.2l.4-.5a39.14,39.14,0,0,1-8.8-9.2C407.2,171.3,407.1,171.5,406.9,171.7Z"
            transform="translate(-19.4 -12.8)"
            fill="#fff"
          />
          <path
            d="M413,192.6l.4-.5c-.1-.1-7.9-5.6-11.4-13.4-.1.2-.3.4-.4.6C405.2,187.1,412.9,192.5,413,192.6Z"
            transform="translate(-19.4 -12.8)"
            fill="#fff"
          />
          <path
            d="M404.6,229.1l.4-.5c-.2-.1-13-9.2-17.1-21.6l-.3.9C391.9,220.1,404.4,229,404.6,229.1Z"
            transform="translate(-19.4 -12.8)"
            fill="#fff"
          />
          <path
            d="M400.2,249.1c-.2-.1-13.5-9.6-17.3-22.3-.1.5-.1.9-.2,1.4,4.3,12.3,17,21.3,17.1,21.4Z"
            transform="translate(-19.4 -12.8)"
            fill="#fff"
          />
          <path
            d="M394.9,190.8a2.51,2.51,0,0,1-.4.7c4.8,10,14.7,17.1,14.9,17.2l.4-.5C409.6,208,399.5,200.8,394.9,190.8Z"
            transform="translate(-19.4 -12.8)"
            fill="#fff"
          />
        </g>
        <g id="nuage1">
          <path
            d="M334.3,70.2a10.6,10.6,0,0,0-20-4.9c-.1,0-.2-.1-.3-.1a13.57,13.57,0,0,0-10.4-4.3,14.75,14.75,0,0,0-7.7,2.1,15.43,15.43,0,0,0-27.4,3.1,10.76,10.76,0,0,0-5.3-1.4A11,11,0,0,0,252.8,72a10,10,0,0,0-4.2-1,9.37,9.37,0,0,0-8.4,5.3h93.3a6.6,6.6,0,0,0,.1-1.4,3.4,3.4,0,0,0-.1-1A7.46,7.46,0,0,0,334.3,70.2Z"
            transform="translate(-19.4 -12.8)"
            fill="#c3cae5"
          />
          <path d="M240.4,75.9l3.6-3.6A8.91,8.91,0,0,0,240.4,75.9Z" transform="translate(-19.4 -12.8)" fill="#fff" />
          <path
            d="M247.1,71.2l-5.2,5.2h.7l5.3-5.3C247.7,71.1,247.4,71.2,247.1,71.2Z"
            transform="translate(-19.4 -12.8)"
            fill="#fff"
          />
          <path
            d="M249.9,71.2l-5.2,5.2h.7l5.1-5.1A1.27,1.27,0,0,1,249.9,71.2Z"
            transform="translate(-19.4 -12.8)"
            fill="#fff"
          />
          <path
            d="M252.1,71.9l-4.6,4.6h.7l4.3-4.3C252.5,72,252.3,71.9,252.1,71.9Z"
            transform="translate(-19.4 -12.8)"
            fill="#fff"
          />
          <path
            d="M259.1,65.6a9.14,9.14,0,0,0-1.4.7l-4.2,4.2a5.91,5.91,0,0,0-.6,1.4Z"
            transform="translate(-19.4 -12.8)"
            fill="#fff"
          />
          <path d="M261.9,64.9,250.4,76.4h.7l11.5-11.5Z" transform="translate(-19.4 -12.8)" fill="#fff" />
          <path
            d="M264.7,65,253.2,76.5h.7l11.4-11.4A1.27,1.27,0,0,0,264.7,65Z"
            transform="translate(-19.4 -12.8)"
            fill="#fff"
          />
          <path d="M270,63.2l4.5-4.5A14.86,14.86,0,0,0,270,63.2Z" transform="translate(-19.4 -12.8)" fill="#fff" />
          <path
            d="M266.9,65.5,256,76.4h.7l10.7-10.7A1.69,1.69,0,0,1,266.9,65.5Z"
            transform="translate(-19.4 -12.8)"
            fill="#fff"
          />
          <path d="M278.5,56.8,258.9,76.4h.7l19.9-19.9Z" transform="translate(-19.4 -12.8)" fill="#fff" />
          <path d="M282,56.1,261.7,76.4h.7l20.3-20.3Z" transform="translate(-19.4 -12.8)" fill="#fff" />
          <path
            d="M284.7,56.2,264.5,76.4h.7l20.1-20.1C285.1,56.3,284.9,56.2,284.7,56.2Z"
            transform="translate(-19.4 -12.8)"
            fill="#fff"
          />
          <path
            d="M287.1,56.7,267.3,76.5h.7l19.6-19.6A.76.76,0,0,0,287.1,56.7Z"
            transform="translate(-19.4 -12.8)"
            fill="#fff"
          />
          <path
            d="M289.2,57.4l-19,19h.7l18.8-18.8C289.5,57.5,289.3,57.5,289.2,57.4Z"
            transform="translate(-19.4 -12.8)"
            fill="#fff"
          />
          <path
            d="M291,58.4l-18,18h.7l17.8-17.8C291.3,58.5,291.2,58.4,291,58.4Z"
            transform="translate(-19.4 -12.8)"
            fill="#fff"
          />
          <path
            d="M292.7,59.5,275.8,76.4h.7l16.6-16.6C293,59.7,292.8,59.6,292.7,59.5Z"
            transform="translate(-19.4 -12.8)"
            fill="#fff"
          />
          <path
            d="M294.2,60.9,278.6,76.5h.7l15.2-15.2A1.38,1.38,0,0,0,294.2,60.9Z"
            transform="translate(-19.4 -12.8)"
            fill="#fff"
          />
          <path
            d="M295.5,62.4l-14,14h.7l13.6-13.6C295.7,62.7,295.6,62.5,295.5,62.4Z"
            transform="translate(-19.4 -12.8)"
            fill="#fff"
          />
          <path
            d="M298.9,61.8,284.2,76.5h.7l14.9-14.9A3.71,3.71,0,0,0,298.9,61.8Z"
            transform="translate(-19.4 -12.8)"
            fill="#fff"
          />
          <path
            d="M302.4,61.1,287.1,76.4h.7L303.2,61A2.2,2.2,0,0,1,302.4,61.1Z"
            transform="translate(-19.4 -12.8)"
            fill="#fff"
          />
          <path
            d="M305.2,61.1,289.9,76.4h.7l15.2-15.2C305.6,61.2,305.4,61.1,305.2,61.1Z"
            transform="translate(-19.4 -12.8)"
            fill="#fff"
          />
          <path
            d="M307.6,61.5,292.7,76.4h.7l14.7-14.7C308,61.6,307.8,61.6,307.6,61.5Z"
            transform="translate(-19.4 -12.8)"
            fill="#fff"
          />
          <path
            d="M309.7,62.2,295.5,76.4h.7l14-14A1.69,1.69,0,0,1,309.7,62.2Z"
            transform="translate(-19.4 -12.8)"
            fill="#fff"
          />
          <path
            d="M311.6,63.2,298.4,76.4h.7L312,63.5C311.9,63.4,311.7,63.3,311.6,63.2Z"
            transform="translate(-19.4 -12.8)"
            fill="#fff"
          />
          <path
            d="M313.2,64.4l-12,12h.7l11.7-11.7C313.4,64.7,313.3,64.5,313.2,64.4Z"
            transform="translate(-19.4 -12.8)"
            fill="#fff"
          />
          <path
            d="M320.1,60.4,304,76.4h.7L321.1,60A4.18,4.18,0,0,0,320.1,60.4Z"
            transform="translate(-19.4 -12.8)"
            fill="#fff"
          />
          <path d="M323.8,59.7h-.2L306.9,76.4h.7l16.7-16.7Z" transform="translate(-19.4 -12.8)" fill="#fff" />
          <path
            d="M326.1,60,309.6,76.5h.7l16.3-16.3A.76.76,0,0,0,326.1,60Z"
            transform="translate(-19.4 -12.8)"
            fill="#fff"
          />
          <path
            d="M328.2,60.7,312.5,76.4h.7l15.5-15.5C328.5,60.8,328.4,60.8,328.2,60.7Z"
            transform="translate(-19.4 -12.8)"
            fill="#fff"
          />
          <path
            d="M330,61.7,315.3,76.4h.7L330.4,62C330.3,61.9,330.1,61.8,330,61.7Z"
            transform="translate(-19.4 -12.8)"
            fill="#fff"
          />
          <path
            d="M331.5,63.1,318.1,76.5h.7l13-13A1.38,1.38,0,0,0,331.5,63.1Z"
            transform="translate(-19.4 -12.8)"
            fill="#fff"
          />
          <path
            d="M332.7,64.7,320.9,76.5h.7l11.3-11.3A.76.76,0,0,0,332.7,64.7Z"
            transform="translate(-19.4 -12.8)"
            fill="#fff"
          />
          <path
            d="M333.6,66.6l-9.9,9.9h.7l9.3-9.3A.56.56,0,0,0,333.6,66.6Z"
            transform="translate(-19.4 -12.8)"
            fill="#fff"
          />
          <path
            d="M334.2,68.8l-7.6,7.6h.7l7-7C334.3,69.2,334.2,69,334.2,68.8Z"
            transform="translate(-19.4 -12.8)"
            fill="#fff"
          />
          <path
            d="M334.2,71.6l-4.8,4.8h.7l3.9-3.9A2.92,2.92,0,0,0,334.2,71.6Z"
            transform="translate(-19.4 -12.8)"
            fill="#fff"
          />
          <path
            d="M333.7,75l-1.4,1.4h.8l.7-.7A1.48,1.48,0,0,1,333.7,75Z"
            transform="translate(-19.4 -12.8)"
            fill="#fff"
          />
        </g>
        <path
          d="M186.6,58.7a46.42,46.42,0,0,0-31-12.5,1.39,1.39,0,0,0-.9,0h-.1a46.37,46.37,0,0,0-46,46.4h0a46.21,46.21,0,0,0,14.5,33.7c.1.1.1.2.2.2s.1.1.2.1a46.67,46.67,0,0,0,31.1,12.3h.5a46.36,46.36,0,0,0,46.2-46.3h0A46,46,0,0,0,186.6,58.7ZM198.5,91H179.8a54.66,54.66,0,0,0-5.2-22.1,47.35,47.35,0,0,0,11.1-7.3A44.49,44.49,0,0,1,198.5,91Zm-45-20.7a45.53,45.53,0,0,1-13.7-3.1,57,57,0,0,1,13.7-16.5Zm2.9-19.9a56.37,56.37,0,0,1,14.1,17.1,42.62,42.62,0,0,1-14.1,2.8Zm16.8,15.9a59,59,0,0,0-13.7-17,42.78,42.78,0,0,1,23.9,10.4A40.56,40.56,0,0,1,173.2,66.3Zm-36.1-.2a44.46,44.46,0,0,1-10.5-6.4,42.68,42.68,0,0,1,24.2-10.4A58.18,58.18,0,0,0,137.1,66.1Zm1.4,3.7a48.73,48.73,0,0,0,15.1,3.4V91H133.3A50.58,50.58,0,0,1,138.5,69.8Zm15,24.1v18a48.27,48.27,0,0,0-15.1,3,51.57,51.57,0,0,1-5.1-21.1h20.2Zm2.9,21a42.94,42.94,0,0,1,13.8,2.8,59.09,59.09,0,0,1-13.8,16.6Zm-2.9,19.3a57.45,57.45,0,0,1-13.8-16.6,40.33,40.33,0,0,1,13.8-2.7ZM137,118.7a59.78,59.78,0,0,0,13.9,17.1,43.68,43.68,0,0,1-24.4-10.5A44.19,44.19,0,0,1,137,118.7Zm36,.1a41.7,41.7,0,0,1,10.4,6.6A42.87,42.87,0,0,1,159,135.8,60,60,0,0,0,173,118.8Zm-1.4-3.7a46.81,46.81,0,0,0-15.2-3.1V94h20.4A52.08,52.08,0,0,1,171.6,115.1ZM156.4,91V73.2a47.45,47.45,0,0,0,15.4-3.1,52.63,52.63,0,0,1,5,21H156.4Zm-32-29.3a46.88,46.88,0,0,0,11.4,7,54.65,54.65,0,0,0-5.4,22.4H111.6A43.17,43.17,0,0,1,124.4,61.7ZM111.6,93.9h18.8a55.24,55.24,0,0,0,5.3,22.2,46.51,46.51,0,0,0-11.3,7.3A42.72,42.72,0,0,1,111.6,93.9Zm74,29.5a46.51,46.51,0,0,0-11.3-7.3,53.82,53.82,0,0,0,5.4-22.3h18.7A42.58,42.58,0,0,1,185.6,123.4Z"
          transform="translate(-19.4 -12.8)"
          fill="#c3cae5"
        />
        <polygon
          points="105.1 257.8 94.1 258 100.5 270.2 409.3 270.2 415.8 258 414.2 257.8 105.1 257.8"
          fill="#303747"
        />
        <path d="M312,271.3c-2.2,3.8-5.2,6-8.5,6H241.3c-3.3,0-6.3-2.2-8.5-6Z" transform="translate(-19.4 -12.8)" />
        <path
          d="M160.5,255.3H388V104.9a4.48,4.48,0,0,0-4.5-4.5H165a4.48,4.48,0,0,0-4.5,4.5Z"
          transform="translate(-19.4 -12.8)"
          fill="#1b202d"
        />
        <rect x="147.4" y="94.54" width="215" height="136.8" fill="#fff" />
        <rect x="147.4" y="94.54" width="215" height="136.8" fill="#fff" />
        <rect x="147.4" y="94.54" width="215" height="136.8" fill="#def5ff" />
        <rect x="147.4" y="94.6" width="215" height="6.7" fill="#6b707c" />
        <path d="M272,103.9a2.3,2.3,0,1,1,2.3,2.3A2.26,2.26,0,0,1,272,103.9Z" transform="translate(-19.4 -12.8)" />
        <path
          d="M116,271.1H432.6c2.9,0,4.3-1,2.3-1.6l-46.6-14.4h-228l-46.6,14.4C111.7,270.1,113.1,271.1,116,271.1Z"
          transform="translate(-19.4 -12.8)"
          fill="#1b202d"
        />
        <polygon points="189.7 255.8 320.1 255.8 309.6 251.8 199.8 251.8 189.7 255.8" fill="#6b707c" />
        <polygon points="390 249.8 119.8 249.8 141.1 243 368.7 243 390 249.8" fill="#6b707c" />
        <rect x="147.49" y="101.02" width="214.7" height="135.6" fill="#ebeef7" />
        <path
          d="M178.7,146.8c-.1.1-.5,3.2,1,4.5l.1.1a2.09,2.09,0,0,1,.6.4h0a14.17,14.17,0,0,0,3.3,1.2,6.63,6.63,0,0,0,1.9,1.2h4.7a6.7,6.7,0,0,0,10.6,0h48.2a6.54,6.54,0,0,0,5.3,2.6,6.8,6.8,0,0,0,5.1-2.3c1.7.1,3,.1,3.1.1a8.76,8.76,0,0,0,5-1.2c3.9-1.5,1.5-1.9,1.5-1.9v-.4c0-.2-.4-.4-.4-.4v-.4a5.55,5.55,0,0,1,.2-1.7v-.1h0v-.1h0v-.1c.2-1,.5-2.4.1-2.8s-9.6-7.2-26.4-8h-4.2a.1.1,0,0,1-.1-.1h0a.1.1,0,0,1-.1-.1h0a.1.1,0,0,1-.1-.1h0a.35.35,0,0,0-.2-.1h0a.1.1,0,0,1-.1-.1c-3-1.5-8.2-3.9-11.4-4.5a2.44,2.44,0,0,0-1.2,0,4.07,4.07,0,0,0-1,.2c-.2.1-1.1,1.2-1,1.6,0,.2,2.8,1.4,6,2.8v.1l-.4,1.5c-2.8-.2-6.1-.5-9.3-.7-.4-1.4-.9-2.9-1.5-3.2-1.1-.5-2.1.5-2.4.9a9.13,9.13,0,0,0-.3,2c-1.6-.1-3.2-.2-4.5-.3-2.6-.2-4.8-.3-6.8-.4a2,2,0,0,0-2.6-2.1c-2.6.4-4,1-4.1,1.6v.2a23.52,23.52,0,0,0-2.8.1c-2.9.2-8.3,1.3-8.3,1.3-.8.2-3.6-.7-4.8-.7s-1.7.8-1.5,1.3a1.42,1.42,0,0,1,.2.6v.1a.64.64,0,0,1,0,.6h0c-.5.4-.8,3.6-.1,3.7h.1c-.2.2-1.3.8-1.3,1.1v1h0v.3h0v.1h0v.1h0v.1h0v.2h0v.3h0l.1.1v.1C178.8,146.6,178.8,146.7,178.7,146.8Zm50.7-8.8.3-1.2c.4.2.9.4,1.3.6a.49.49,0,0,0-.6.3l-.1.4h-.6Zm-.6-1.6c.3.1.6.3.9.4C229.4,136.7,229.1,136.5,228.8,136.4Z"
          transform="translate(-19.4 -12.8)"
          fill="#c3cae5"
        />
        <path
          d="M282.2,148.1a3.4,3.4,0,0,1-.2-1.4c0-1,1.2-2.7,1.2-2.8h0c.1-.3.8-2.1,1-2.5s0-.8.1-1.2a6.24,6.24,0,0,1,1-1.6c-.8-.5.2-.6.9-.6a63.2,63.2,0,0,0,7.3-.9,87.44,87.44,0,0,1,11.8-4.2c1.8-.4,13.8-2.1,22.3-1s14.5,6.6,16.1,6.7h.6c2.7.2,11.2.9,14.7,1.2a18,18,0,0,1,7.7,2.5c1.7,1.2,1.8,4.2,1.8,4.9a8.9,8.9,0,0,1,.2,4.8,4.92,4.92,0,0,1-1.7.6,5.1,5.1,0,0,1-2.6,1.2h-2.9a6.68,6.68,0,0,1-5.5,2.8,6.51,6.51,0,0,1-5.5-2.9c-12.8-.1-31.5-.3-43.6-.4a6.73,6.73,0,0,1-11.7-.2c-1.2.1-14.1-1.5-13-5Z"
          transform="translate(-19.4 -12.8)"
          fill="#c3cae5"
        />
        <path
          d="M176.5,218.1v-.5h0v-.4h0v-.1h0a1.25,1.25,0,0,1,1.1-.6h.1a2.77,2.77,0,0,1,.9.1c.8.2,1.5.5,1.6.5a3.25,3.25,0,0,1,1.2,1.5c0,.1.1.1.1.2h0c.2.3.7.3.9.3.9-2.6,2.9-7.6,4.6-8.4,2.3-1.1,12.8-1,13.1-1s10.7-.1,13.1,1c1.7.8,3.7,5.8,4.6,8.4.2,0,.8,0,1-.3h0c0-.1.1-.1.1-.2a3.25,3.25,0,0,1,1.2-1.5,7.48,7.48,0,0,1,1.6-.5,2.77,2.77,0,0,1,.9-.1h.1a1.15,1.15,0,0,1,1.1.6h0v.6h0v.6h0v.3a.1.1,0,0,1-.1.1h0a.1.1,0,0,1-.1.1v.1h0l-.2.2h-.1c-.1,0-.1.1-.2.1a995164323832.17,995164323832.17,0,0,1-.2.2h-.2a.1.1,0,0,0-.1.1h-.7c-.2.1-.4.1-.6.2H218a.65.65,0,0,0,.7.6,2.75,2.75,0,0,0,1.1.8c.7.3,2.2.8,2.2,1.1s.1.6.3.7,1,.3,1,1.5c0,.5-.1,2.8-.2,5.3a.91.91,0,0,1,.4.8v9.3a1.08,1.08,0,0,1-1,1h-6.9a.94.94,0,0,1-1-1v-.3H186.3v.3a1.08,1.08,0,0,1-1,1h-7.6a.94.94,0,0,1-1-1v-9.3a1.05,1.05,0,0,1,.5-.9c-.1-2.4-.2-4.7-.2-5.3,0-1.2.8-1.3,1-1.5s.2-.5.3-.7a11,11,0,0,1,2.2-1.1,2.75,2.75,0,0,0,1.1-.8,1.1,1.1,0,0,1,.6-.3h-.1a.77.77,0,0,1,.1-.3h-3.1c-.2-.1-.4-.1-.6-.2h-.7a.1.1,0,0,1-.1-.1h-.1l-.1-.1a.1.1,0,0,1-.1-.1h-.1l-.1-.1h0l-.2-.2h0l-.1-.1v-.1a.1.1,0,0,0-.1-.1h0v-.2c0-.1,0-.1-.1-.2V218c-.2.2-.2.1-.2.1Z"
          transform="translate(-19.4 -12.8)"
          fill="#c3cae5"
        />
        <path
          d="M229.7,231.6a3.12,3.12,0,0,0,.7-2c0-.2.2-.3.5-.3h-.5a.22.22,0,0,1-.2-.2v-2.2a.22.22,0,0,1,.2-.2h.7a.46.46,0,0,1-.5-.4v-.5a.46.46,0,0,1,.5-.4h-.7a.22.22,0,0,1-.2-.2V223a.22.22,0,0,1,.2-.2h.8c-.3,0-.6-.2-.5-.5h0a12,12,0,0,1,1.4-1.2l.1-.1h0l.1-.1h0l.1-.1h0l.1-.1h0c.7-2.3,2.3-7.7,2.8-8.3a6.83,6.83,0,0,1,1.9-1.3H243c8-.6,21.9,1,23.8,1.6a7.72,7.72,0,0,1,1.5.6c2.3.6,7.6,2.8,16,10.1a2.19,2.19,0,0,1,1.7.9c1.1.4,6,2.9,4.5,7.1.6.3,4.1,4,2.1,7.8h-1a.79.79,0,0,1-.8.5h-3.6a3.32,3.32,0,0,1-1,1.4,5.87,5.87,0,0,1-8,.4,17.38,17.38,0,0,1-1.3-1.5H245a4.44,4.44,0,0,1-.8,1.1,5.8,5.8,0,0,1-9.4-1.4h-3.4a1,1,0,0,1-1-.5,1.21,1.21,0,0,1-1-.8C229.1,235.5,228.7,232.5,229.7,231.6Z"
          transform="translate(-19.4 -12.8)"
          fill="#c3cae5"
        />
        <rect x="147.49" y="234.31" width="214.7" height="2.4" fill="#c3cae5" />
        <rect x="359.59" y="101.04" width="3.4" height="135.6" fill="#c3cae5" />
        <rect x="147.47" y="101.06" width="2.5" height="135.6" fill="#c3cae5" />
        <rect x="334.19" y="101.03" width="1.3" height="135.6" fill="#c3cae5" />
        <rect x="307.51" y="101.11" width="1.3" height="135.6" fill="#c3cae5" />
        <rect x="280.83" y="101.09" width="1.3" height="135.6" fill="#c3cae5" />
        <rect x="254.15" y="101.07" width="1.3" height="135.6" fill="#c3cae5" />
        <rect x="227.48" y="101.05" width="1.3" height="135.6" fill="#c3cae5" />
        <rect x="200.8" y="101.03" width="1.3" height="135.6" fill="#c3cae5" />
        <rect x="174.12" y="101.11" width="1.3" height="135.6" fill="#c3cae5" />
        <rect x="147.51" y="147.56" width="214.3" height="18.3" fill="#c3cae5" />
        <rect x="281" y="173.23" width="54.3" height="61" fill="#c3cae5" />
        <rect x="307.53" y="173.32" width="1.3" height="63.4" fill="#ebeef7" />
        <path
          d="M331.7,219.3h.9a1.75,1.75,0,0,0,1.7-1.7v-2.2a1.75,1.75,0,0,0-1.7-1.7h-.9a1.75,1.75,0,0,0-1.7,1.7v2.2A1.69,1.69,0,0,0,331.7,219.3Z"
          transform="translate(-19.4 -12.8)"
          fill="#ebeef7"
        />
        <path
          d="M322.5,219.3h.9a1.75,1.75,0,0,0,1.7-1.7v-2.2a1.75,1.75,0,0,0-1.7-1.7h-.9a1.75,1.75,0,0,0-1.7,1.7v2.2A1.69,1.69,0,0,0,322.5,219.3Z"
          transform="translate(-19.4 -12.8)"
          fill="#ebeef7"
        />
        <path
          d="M160.49,288.07h-.32a1.47,1.47,0,0,1-1.12-1.77l5.62-23.13a1.48,1.48,0,1,1,2.89.64l-5.62,23.13A1.38,1.38,0,0,1,160.49,288.07Z"
          transform="translate(-19.4 -12.8)"
          fill="#20232e"
        />
        <path
          d="M128.68,288.07h-.32a1.47,1.47,0,0,1-1.12-1.77l8.19-33.42a1.48,1.48,0,0,1,2.89.65l-8.19,33.41A1.38,1.38,0,0,1,128.68,288.07Z"
          transform="translate(-19.4 -12.8)"
          fill="#20232e"
        />
        <path
          d="M141.37,167.25c56.39,0,45.63,58,63.46,57s26,41-38.72,41S89.48,167.25,141.37,167.25Z"
          transform="translate(-19.4 -12.8)"
          fill="#9297a5"
        />
        <path
          d="M221.22,275.54s-.16,10,0,10.12a11.79,11.79,0,0,1-.8,1.45l-3.22.64-2.89-1.29s.32-9.32,0-10.76C214,274.09,221.22,275.54,221.22,275.54Z"
          transform="translate(-19.4 -12.8)"
          fill="#f2bbb8"
        />
        <path
          d="M214.31,286.3a8.21,8.21,0,0,0,6.75-.8s12.05,4.5,11.73,8c0,0,.48,1-4.66.8-5.3-.16-13.34-.48-13.66-.64C214.31,293.53,213.35,294.17,214.31,286.3Z"
          transform="translate(-19.4 -12.8)"
          fill="#20232e"
        />
        <path
          d="M190.7,275.54s-.17,10,0,10.12a11.75,11.75,0,0,1-.81,1.45l-3.21.64-2.89-1.29s.32-9.32,0-10.76C183.63,274.09,190.7,275.54,190.7,275.54Z"
          transform="translate(-19.4 -12.8)"
          fill="#f2bbb8"
        />
        <path
          d="M184,286.3a8.21,8.21,0,0,0,6.75-.8s12,4.5,11.72,8c0,0,.49,1-4.66.8s-13.33-.48-13.65-.64S182.82,294.17,184,286.3Z"
          transform="translate(-19.4 -12.8)"
          fill="#20232e"
        />
        <path
          d="M161.62,159.22s1-1.12,1.6-.64c1.45,1.44-.32,2.89-1.44,3.21Z"
          transform="translate(-19.4 -12.8)"
          fill="#f1917c"
        />
        <path
          d="M162.42,154.72h0v-.32a9.93,9.93,0,0,0-9.64-11.08,10.17,10.17,0,0,0-10.28,8,11.08,11.08,0,0,0,.32,5.14q1,3.62,1.93,6.26a13.83,13.83,0,0,1,.32,9.16l-.64,2.41c5.78,4,9,1.29,9,1.29l.65-4.34a1.06,1.06,0,0,1,1.12-1h0C162.9,170.31,162.1,158.1,162.42,154.72Z"
          transform="translate(-19.4 -12.8)"
          fill="#f2bbb8"
        />
        <path
          d="M151.49,158.74a.88.88,0,1,0-1.76-.16.9.9,0,0,0,.8,1A.74.74,0,0,0,151.49,158.74Z"
          transform="translate(-19.4 -12.8)"
          fill="#20232e"
        />
        <path
          d="M160,158.1a.89.89,0,1,0-1,.8A.9.9,0,0,0,160,158.1Z"
          transform="translate(-19.4 -12.8)"
          fill="#20232e"
        />
        <path
          d="M148.44,157c-.16,0-.16,0-.32-.16a.7.7,0,0,1-.16-.8,2.76,2.76,0,0,1,4-.48c.32.16.32.48.16.8s-.48.32-.81.16a1.77,1.77,0,0,0-2.57.16C148.76,157,148.6,157,148.44,157Z"
          transform="translate(-19.4 -12.8)"
          fill="#20232e"
        />
        <path
          d="M157.28,156.49c-.16,0-.16,0-.32-.16a.7.7,0,0,1-.16-.8,2.76,2.76,0,0,1,4-.49c.32.16.32.49.16.81s-.48.32-.8.16a1.77,1.77,0,0,0-2.57.16C157.6,156.49,157.44,156.49,157.28,156.49Z"
          transform="translate(-19.4 -12.8)"
          fill="#20232e"
        />
        <polygon points="122.13 139.83 124.06 146.9 125.99 146.74 128.08 138.23 122.13 139.83" fill="#20232e" />
        <path
          d="M145.71,159.38a1.6,1.6,0,0,0-.64-.8,2.4,2.4,0,0,0-2.73,0c-1.29,1.12.8,4.66,3.37,3.21A3,3,0,0,0,145.71,159.38Z"
          transform="translate(-19.4 -12.8)"
          fill="#f2bbb8"
        />
        <path
          d="M156,162.75a2.41,2.41,0,0,1-1.76-.16s-.16-.16,0-.16c0,0,.16-.16.16,0a1.49,1.49,0,0,0,1.76,0c.16-.16.32-.16.32-.32s-.16-.32-.32-.48a4.72,4.72,0,0,1-1-3c0-.16,0-.16.16-.16s.16,0,.16.16a4.58,4.58,0,0,0,1,2.89c.17.32.33.48.33.8,0,.16-.16.32-.33.48A.3.3,0,0,0,156,162.75Z"
          transform="translate(-19.4 -12.8)"
          fill="#f1917c"
        />
        <path
          d="M161.29,150.71s1.29,1.12,1,7.23c0,0,1.28-6.75.64-7.56C162.1,149.58,161.29,150.71,161.29,150.71Z"
          transform="translate(-19.4 -12.8)"
          fill="#20232e"
        />
        <path
          d="M156.64,166a2.17,2.17,0,0,0,1.28-.81V165h-.16c-1.93,1.93-4.34-.16-4.5-.32h-.16v.16A3.9,3.9,0,0,0,156.64,166Z"
          transform="translate(-19.4 -12.8)"
          fill="#20232e"
        />
        <path
          d="M141.05,150.38a10.29,10.29,0,0,1,1.61-4.17,2.47,2.47,0,0,1-2.09-.32c-.64-.49-.48-1.61.16-1.61.48-.16.8.16,1.13.32,1,.16,1.6-.8,1.92-1.77s.48-1.92,1.45-2.41a1.74,1.74,0,0,1,.8-.16,5.5,5.5,0,0,1-.48,3.22,16,16,0,0,1,4-3.38,5.17,5.17,0,0,1,4-.64c.32,1.12-1.44,1.61-1.76,2.57a22.19,22.19,0,0,1,7.23-.64,5.75,5.75,0,0,1,1.76.32,2.57,2.57,0,0,1,1.13,1.44c0,.81-.65,1.61-1.45,1.45a14.2,14.2,0,0,1,3.38,1.93,5.14,5.14,0,0,1,1.92,3.37,5.13,5.13,0,0,1-2.57-.64c.48.48,1,1.28.65,1.93a1.45,1.45,0,0,1-1.29.8,5.82,5.82,0,0,1-1.61-.32l-7.71-2.41a9,9,0,0,1,2.09,3.86,13,13,0,0,1-6.27-2.74A12.87,12.87,0,0,1,148,153.6c-.16.16-.16.32-.32.48-.48.32-1-.48-1.45-.8a1.68,1.68,0,0,0-2.09.16c-1.12.64-1.92,1.44-2.73.16A20,20,0,0,1,141.05,150.38Z"
          transform="translate(-19.4 -12.8)"
          fill="#20232e"
        />
        <path
          d="M208.53,226.05S220.26,227,224,242c2.25,8.68,1.29,36.79,1.29,36.79l-15.1,2.41s1.28-31.49-10.45-41.13c0,0,2.41,6.43-6.26,42.74H182.18l-3.69-37.28s-26.51.81-34.39-5.78-8.67-14.46-8.67-14.46l37.43-5.62Z"
          transform="translate(-19.4 -12.8)"
          fill="#fff"
        />
        <path
          d="M141.37,175.45s.81-5.63,1.93-5.3,11.57,2.24,12.69,1.92c1-.16,0,4.82,0,4.82S167.72,178,170.61,183s9.8,23.94,12.21,25.54a73.05,73.05,0,0,1,7.39,6.11L170,226.05l-19.28-1s-14,8.35-24.74,1.77c-10.93-6.43-9-40.65,1.29-46.59S141.37,175.45,141.37,175.45Z"
          transform="translate(-19.4 -12.8)"
          fill="#20232e"
        />
        <path
          d="M175.59,220.75h0c-5.94-2.57-9-27.95-9.15-28.92,0-.16,0-.16.16-.16s.16,0,.16.16c0,.33,3.21,26.19,9,28.76l-.16.16Z"
          transform="translate(-19.4 -12.8)"
          fill="#20232e"
        />
        <path
          d="M150.69,225.25h0c-.16-.16-.16-.32,0-.32l4.18-1.93-.64-7.39c-1.29-.32-13.18-2.57-19-3.21a.16.16,0,0,1-.16-.16c0-.64-.16-14,.64-15.91,0,0,.16-.16.16,0,0,0,.16.16,0,.16-.8,1.77-.64,14.3-.64,15.75,6.1.64,18.8,3.21,19,3.21a.16.16,0,0,1,.16.16l.64,7.55a.16.16,0,0,1-.16.16l-4.18,1.93Z"
          transform="translate(-19.4 -12.8)"
          fill="#20232e"
        />
        <path
          d="M199.69,240h0c-.16-.32-2.89-13.17-23.94-14.78-.16,0-.16,0-.16-.16s0-.16.16-.16c11.25.8,17.19,4.82,20.25,8,3.37,3.54,4,6.75,4,6.91-.16,0-.16.16-.32.16Z"
          transform="translate(-19.4 -12.8)"
          fill="#20232e"
        />
        <path
          d="M158.4,216.58h.81c2.41,0,9.64.32,10.44.64,1,.32-2.09,6.59-2.09,6.59s-8.68.48-11.41-1.45C153.42,220.75,158.4,216.58,158.4,216.58Z"
          transform="translate(-19.4 -12.8)"
          fill="#f2bbb8"
        />
        <path
          d="M166.44,224s4.82,2.25,5.3,1.76-3.86-2.89-3.86-2.89Z"
          transform="translate(-19.4 -12.8)"
          fill="#f2bbb8"
        />
        <path
          d="M167.88,222.36s7.23,2.89,7.71,1.93-7.39-3.54-7.39-3.54Z"
          transform="translate(-19.4 -12.8)"
          fill="#f2bbb8"
        />
        <path
          d="M168.85,220.75s7.39,2.25,7.87,1.29-7.71-2.89-7.71-2.89Z"
          transform="translate(-19.4 -12.8)"
          fill="#f2bbb8"
        />
        <path
          d="M169.17,218.82s6.91,2.25,7.39,1.29-7.23-2.89-7.23-2.89Z"
          transform="translate(-19.4 -12.8)"
          fill="#f2bbb8"
        />
        <polygon points="140.61 204.1 135.15 203.45 135.79 209.56 138.52 210.2 140.61 204.1" fill="#f2bbb8" />
        <polygon
          points="202.3 184.98 162.46 184.98 149.93 214.06 189.77 214.22 202.3 184.98"
          fill={props.color1 ? props.color1 : '#ff4137'}
        />
        <rect
          x="162.98"
          y="212.64"
          width="1.77"
          height="26.67"
          transform="translate(-81.74 376.72) rotate(-89.92)"
          fill={props.color1 ? props.color1 : '#ff4137'}
        />
        <path
          d="M197.76,211.92a1.77,1.77,0,1,1,1.77,1.76A1.79,1.79,0,0,1,197.76,211.92Z"
          transform="translate(-19.4 -12.8)"
          fill="#fff"
        />
      </g>
    </svg>
  );
}

export default IllustrationCompteSvg;
